import { Card, Grid } from '@mui/material';
import { ReactNode } from 'react';

import { SettingsHeader } from '../SettingsHeader';
import SettingsIndex, { IOption } from '../SettingsIndex';
import { IBreadCrumbsList, WsBreadCrumbs } from '../WsBreadCrumbs';

type PropsType = {
  title: string;
  children: ReactNode;
  indexOptions: IOption[];
  backUrl?: string;
  goBackRequired?: boolean;
  hideCard?: boolean;
  breadCrumnbsList?: IBreadCrumbsList[];
};

export const SettingsPageLayout = ({
  children,
  title,
  indexOptions,
  hideCard = false,
  breadCrumnbsList = [],
}: PropsType) => (
  <Grid container columnSpacing={3} rowSpacing={4}>
    <Grid item xs={12}>
      <WsBreadCrumbs breadCrumbsList={breadCrumnbsList} />
      <SettingsHeader title={title} />
    </Grid>

    <Grid item xs={3}>
      <SettingsIndex index={''} options={indexOptions} />
    </Grid>

    <Grid item xs={9}>
      {hideCard ? (
        children
      ) : (
        <Card sx={{ minHeight: '83vh', width: '100%', p: '0' }}>{children}</Card>
      )}
    </Grid>
  </Grid>
);
